module.exports = __webpack_public_path__ + "img/success-with-dg-woodpacking-bosspack.4c4f7afe.svg";